import {announce} from '@github-ui/aria-live'
import {useMarkReadyForReviewMutation} from '@github-ui/mergebox/use-mark-ready-for-review-mutation'
import {Button} from '@primer/react'

import {FailureDialog} from '../../../../FailureDialog'
import {useInvalidatePrState} from '../../../../../hooks/use-invalidate-pr-state'
import {usePullRequestAnalytics} from '../../../../../hooks/use-pull-request-analytics'
import {PullRequestState} from '../../../../../types'
import {useLayoutQuery} from '../../../../../page-data/loaders/use-layout-query'

export function OverviewReadyForReviewControl({inactive, itemName}: {inactive?: boolean; itemName: string}) {
  const {pullRequest, user} = useLayoutQuery().data
  const invalidatePrState = useInvalidatePrState()
  const {sendPullRequestAnalyticsEvent} = usePullRequestAnalytics()
  const markReadyForReviewMutation = useMarkReadyForReviewMutation({
    onSuccess: () => {
      announce('Pull request marked as ready for review')
      invalidatePrState(PullRequestState.Open)
    },
  })

  if (pullRequest.state !== PullRequestState.Draft || !user?.canMarkReadyForReview) return null

  return (
    <>
      <Button
        size="small"
        inactive={inactive}
        loading={markReadyForReviewMutation.isPending}
        loadingAnnouncement="Marking ready for review"
        onClick={() => {
          if (inactive || markReadyForReviewMutation.isPending) return

          sendPullRequestAnalyticsEvent('overview.for_you_item_action', 'OVERVIEW_FOR_YOU_ITEM', {
            item_name: itemName,
            action_name: 'mark_ready_for_review',
          })
          markReadyForReviewMutation.mutate()
        }}
      >
        Ready for review
      </Button>
      {markReadyForReviewMutation.isError && (
        <FailureDialog
          title="Failed to mark ready for review"
          message="An error occurred while marking this pull request as ready for review. Please try again."
          details={markReadyForReviewMutation.error.message}
          onRetry={() => markReadyForReviewMutation.mutate()}
          onDismiss={() => markReadyForReviewMutation.reset()}
        />
      )}
    </>
  )
}
